import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getCarrierStateOfficeCodes = async () => {
  const { data } = await axios.get(`${api_base_url}/Report`);
  return data;
};
export const getCarrierAgreementsReport = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/EntityCommision`);
  return data;
};
export const getCarrierAgreement = async (searchIdandState) => {
  const [_key, filters] = searchIdandState.queryKey;

  //Recontruct filter parameter as Query String for GET Method [FromQuery]
  var queryStrings = new URLSearchParams();
  filters.searchId && queryStrings.append("SearchId", filters.searchId);
  filters.state && queryStrings.append("State", filters.state);
  filters.entityName && queryStrings.append("EntityName", filters.entityName);
  //filters.EntityId && queryStrings.append("EntityId", filters.entityId);

  var filterParams = {
    params: queryStrings,
  };
  return await axios.get(
    `${api_base_url}/Report/searchIdandState`,
    filterParams
  );
};
export const getCarrierExceptionReport = async (Exceptions) => {
  return await axios.post(`${api_base_url}/Report/Exceptions`, Exceptions);
};
export const getActiveEmployees = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/ActiveEmployees`);
  return data;
};

export const getPendingTermination = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/PendingTermination`);
  return data;
};
export const getActiveEmployeesNoEmailAddress = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Report/ActiveEmployeesNoEmailAddress`
  );
  return data;
};
export const getActiveAtClosedLocation = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Report/ActiveEmployeesAtClosedLocation`
  );
  return data;
};
export const getEmployeesWithTerminatedSupervisors = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Report/EmployeesWithTerminatedSupervisors`
  );
  return data;
};
export const getActiveTempReport = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/ActiveTempReport`);
  return data;
};
export const getActiveNoEmployeeId = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/ActiveNoEmployeeId`);
  return data;
};

export const getAllSalesforce = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/SalesforceAll`);
  return data;
};

export const getAllTressEmployees = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/AllTressEmployees`);
  return data;
};

export const getAllSnowflakesDetails = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/AllSnowflake`);
  return data;
};

export const getAllMappedSnowflakesCount = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Report/MappedSnowflakeCount`
  );
  return data;
};

export const getAllAL3Data = async () => {
  const response = await axios.get(`${api_base_url}/Report/AllAL3DataReport`);
  return response;
};

export const getAllMappedAL3DataCount = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/MappedAL3DataCount`);
  return data;
};

export const getCarrierEAndOData = async () => {
  const { data } = await axios.get(`${api_base_url}/Report/CarrierEAndOData`);
  return data;
};
